//请自行添加语言资源
const credit = {
  customerName:'客户名称',
  customerNo:'客户编码',
  creditAccount:'信贷账户',
  creditLimit:'信贷限额',
  receivables: '已使用额度',
  specialLiabilities: 'Special liabilities',
  salesValue: '销售额度',
  creditExposure: '已超信用额度(非信贷客户为账户余额)',
  overdueAmount: '已逾期金额',
  sevenOverdueAmount:'7天即将逾期金额',

  accountBank:'银行账号',
  updateTime:'更新时间',
  bankDeposit:'开户行',
  accountName:'银行账户',
  // creditName:'信贷账户名称',
  msg:{
  }
};
export default credit



// WEBPACK FOOTER //
// ./src/page/finance/credit/lang/credit.zh.js